import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AnimationOptions } from 'ngx-lottie';
import { tap } from 'rxjs';
import { GroupService } from 'src/app/services/groupservice.service';
import { CSV_CHECK, PATH_LOADER } from 'src/app/shared/data/data';
import { RequestStatus } from 'src/app/shared/data/models';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-masivecharge',
  templateUrl: './masivecharge.component.html',
  styleUrls: ['./masivecharge.component.scss'],
})
export class MasivechargeComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  public inputArchive: FormControl;
  public archivos: any = '';
  public fileIsReady: any;
  public fielCSVUp: File;
  public idGroup: any = this.datadialog.idGroup;
  public errorFileObject: any;
  public options: AnimationOptions;
  public status: RequestStatus = 'init';
  public fileError: boolean = false;
  public textFilesErrors: string[] = CSV_CHECK;
  public errorsInRegisters: number;
  public fileName: string = '';
  public duplicatesInRegisters: number;
  public fileExtension: string;
  public isLoaded: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<MasivechargeComponent>,
    private groupService: GroupService,
    @Inject(MAT_DIALOG_DATA) public datadialog: { idGroup: string },
    private _snackBar: MatSnackBar,
    private trasnlateService: TranslateService
  ) {
    this.options = {
      path: PATH_LOADER,
    };
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {}

  public something(event: any): void {
    event.preventDefault();
    this.archivos = event.target.files[0];
    this.showFiles(this.archivos);
  }

  public eraseFile(): void {
    this.archivos = '';
  }

  public closeModal(query?: number): void {
    this.dialogRef.close(query);
  }

  public showFiles(files: any): void {
    if (files.length == undefined) {
      this.procesFile(files);
    } else {
      for (const file of files) {
        this.procesFile(file);
      }
    }
  }

  public procesFile(file: File): void {
    this.fileExtension = file.type;
    this.fileName = file.name;
    const validExtension = ['text/csv'];

    if (validExtension.includes(file.type)) {
      this.fielCSVUp = file;
      this.isLoaded = true;
      this.groupService
        .uploadCsvFile(this.idGroup, this.fielCSVUp)
        .pipe(tap(() => (this.status = 'init')))
        .subscribe({
          next: ({ totals }: any) => {
            this.status = 'success';
            this.errorsInRegisters = totals.rowsError;
            this.duplicatesInRegisters = totals.rowsDuplicates;
            this.errorRegisters(totals.rows, totals.rowsError);
            const values: string[] = Object.values(totals);
            const errores = this.textFilesErrors.map((item, index) => {
              return `${item}: ${values[index]}`;
            });
            this.textFilesErrors = errores;
          },
          error: () => {
            this.status = 'error';
          },
        });
    } else {
      this.isLoaded = false;
    }
  }

  public donwloadCVS(): void {
    const fileName = `layout_Companys.csv`;
    this.groupService.getLayOutCompanies().subscribe((resp: any) => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(resp);
      a.href = objectUrl;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(objectUrl);
    });
  }

  public sendFileToServer(): void {
    this.openSnackBar('yes');
  }

  public reCharge(): void {
    this.eraseFile();
    this.status = 'init';
    this.textFilesErrors = CSV_CHECK;
  }

  private openSnackBar(query: string): void {
    let change = true;
    this.subs.sink = this.trasnlateService
      .get(['COMPANY.upload-files', 'USERS.undo'])
      .subscribe((valor) => {
        const message = valor['COMPANY.upload-files'];
        const action = valor['USERS.undo'];
        this._snackBar.open(message, action, {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });
        this._snackBar._openedSnackBarRef?.onAction().subscribe(() => {
          change = false;
        });

        this._snackBar._openedSnackBarRef?.afterDismissed().subscribe(() => {
          if (change === true) {
            this.groupService
              .uploadCsvFile(this.idGroup, this.fielCSVUp, query)
              .pipe()
              .subscribe({
                next: () => {
                  this.closeModal(1);
                },
              });
          }
        });
      });
  }

  public noUpload(): void {
    this.subs.sink = this.trasnlateService
      .get(['COMPANY.no-uploadfile', ''])
      .subscribe((valor) => {
        const message = valor['COMPANY.no-uploadfile'];
        const action = '';
        this._snackBar.open(message, action, {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      });
  }

  private errorRegisters(total: number, errors: number): void {
    this.fileError = total == errors ? true : false;
  }
}
